import * as React from "react";
const SvgTokens = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M10 17.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15m0-10.68L6.82 10 10 13.18 13.18 10z" }));
export default SvgTokens;
